import {
  BarChartOutlined, IdcardOutlined,
  HddOutlined, KeyOutlined,
  ProjectOutlined, LineChartOutlined,
  PieChartFilled, ContainerOutlined,
  SlidersOutlined, UserOutlined,
  ImportOutlined, UnorderedListOutlined,
  ExportOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import React, { useState } from 'react';
import utils from '../../utils';
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setShowModalChangePass } from '../../store/reducers/auth/auth'
import { AccessRolesSelector } from '../../store/reducers/permistion';

function getItem(label, key, icon, children, type, disabled) {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled
  };
}
const SiderMenu = () => {
  const dispatch = useDispatch()
  const [current, setCurrent] = useState('');
  const AuthSelectors = useSelector(AccessRolesSelector)
  const onClick = (e) => {
    // console.log('click ', e);
    // navigate(e.link, {replace: true})
    if (e.key === 'TK-0001') {
      dispatch(setShowModalChangePass(true))
    }
    setCurrent(e.key);
  };
  let dataMenu = [
    {
      id: 'BC',
      name: 'Báo cáo',
      moduleName: 'DEFAULT',
      action: 'DEFAULT',
      url: '',
      icon: <BarChartOutlined />,
      children: [
        {
          id: 'BC-0002',
          name: 'Doanh số công ty',
          url: '/CompanySales',
          moduleName: 'COMPANY_SALE',
          action: 'READ',
          icon: <BarChartOutlined />,
          children: []
        },
        {
          id: 'BC-0003',
          name: 'Đơn hàng chờ xuất kho',
          url: '/CompanySaleOders',
          moduleName: 'ORDER_WAIT_EXPORT_WAREHOUSE',
          action: 'READ',
          icon: <BarChartOutlined />,
          children: []
        },
        {
          id: 'BC-0005',
          name: 'Doanh số - Đơn hàng',
          url: '/CompanySaleOderDetails',
          moduleName: 'SALE_ORDER',
          action: 'READ',
          icon: <LineChartOutlined />,
          children: []
        },
        {
          id: 'BC-0006',
          name: 'So sánh doanh số cùng kỳ',
          url: '/CompareCompanySales',
          moduleName: 'COMPARE_SALE_SAME_PERIOD',
          action: 'READ',
          icon: <PieChartFilled />,
          children: []
        },
        {
          id: 'BC-0007',
          name: 'Thống kê doanh số từng sales',
          url: '/AOP',
          moduleName: 'SALE_STATISTICS',
          action: 'READ',
          icon: <PieChartFilled />,
          children: []
        },
        {
          id: 'BC-0004',
          name: 'Tồn kho - biểu đồ',
          url: '/StockDashboard',
          moduleName: 'IN_STOCK',
          action: 'READ',
          icon: <ProjectOutlined />,
          children: []
        },
        {
          id: 'BC-0001',
          name: 'Tồn kho - Giữ hàng',
          url: '/tonkhoGiuHang',
          moduleName: 'KEEP_STOCK',
          action: 'READ',
          icon: <HddOutlined />,
          children: []
        },
        {
          id: 'BC-0008',
          name: 'Tồn kho',
          url: '/tonkhoAVP',
          moduleName: 'KEEP_STOCK',
          action: 'READ',
          icon: <HddOutlined />,
          children: []
        },
      ]
    },
    {
      id: 'Quét Barcode',
      name: 'BarCode',
      moduleName: 'DEFAULT',
      action: 'DEFAULT',
      url: '',
      icon: <HddOutlined />,
      children: [
        {
          id: 'IM',
          name: 'Nhập Kho',
          moduleName: 'IMPORT_WAREHOUSE',
          action: 'CREATE',
          url: '/Im',
          icon: <ImportOutlined />,
          children: []
        },
        {
          id: 'LIM',
          name: 'Danh sách nhập kho',
          moduleName: 'IMPORT_WAREHOUSE',
          action: 'READ',
          url: '/ListIm',
          icon: <UnorderedListOutlined />,
          children: []
        },
        {
          id: 'EX',
          name: 'Xuất Kho',
          moduleName: 'EXPORT_WAREHOUSE',
          action: 'CREATE',
          url: '/Ex',
          icon: <ExportOutlined />,
          children: []
        },
        {
          id: 'LEX',
          name: 'Danh sách xuất kho',
          moduleName: 'EXPORT_WAREHOUSE',
          action: 'READ',
          url: '/ListEx',
          icon: <UnorderedListOutlined />,
          children: []
        }
      ]
    },
    {
      id: 'TK',
      name: 'Tài khoản',
      moduleName: 'DEFAULT',
      action: 'DEFAULT',
      url: '',
      icon: <IdcardOutlined />,
      children: [
        {
          id: 'TK-0001',
          name: "Đổi mật khẩu",
          moduleName: 'DEFAULT',
          action: 'DEFAULT',
          url: '',
          icon: <KeyOutlined />,
          children: []
        },
        {
          id: 'PQ',
          name: 'Phân quyền',
          moduleName: 'PERMISSIONS',
          action: 'READ',
          url: '/Permission',
          icon: <ContainerOutlined />,
          children: []
        },
        {
          id: 'NV',
          name: 'Người dùng',
          moduleName: 'USER',
          action: 'READ',
          url: '/User',
          icon: <UserOutlined />,
          children: []
        },
      ]
    },
    {
      id: 'KH',
      name: 'Khác',
      moduleName: 'DEFAULT',
      action: 'DEFAULT',
      url: '',
      icon: <SlidersOutlined />,
      children: [
        {
          id: 'KH-0001',
          name: "Tình trạng dịch vụ IT",
          moduleName: 'DEFAULT',
          action: 'DEFAULT',
          url: '/servicesStatus',
          icon: <SlidersOutlined />,
          children: []
        }
      ]
    },

  ]


  let menuGenerate = (data) => {
    return data?.length && data.map((item) => {
      if (utils.checkPermistion(AuthSelectors, item.moduleName, item.action)) {
        return getItem(item?.url !== '' ? <Link to={item?.url}>{item?.name}</Link> : item?.name, item?.id, item?.icon, item.children?.length > 0 ? menuGenerate(item?.children) : '')
      }
    });
  }

  const items = menuGenerate(dataMenu)
  return (
    <>
      <Menu
        theme='light'
        onClick={onClick}
        selectedKeys={[current]}
        mode="inline"
        items={items}
        style={{ height: "100%", borderRight: 0 }}
      />
    </>
  );
};

export default SiderMenu;